module.exports = __webpack_public_path__ + "angular/components/directives/ebReadOnlyField-d7a1782f.html";


//////////////////
// WEBPACK FOOTER
// ./source/angular/components/admin/directives/ebReadOnlyField.html
// module id = 47
// module chunks = 0